import ReactGA from 'react-ga4';
import constants from '@playcastdotio/GlobalConfig';
import { PlaycastAnalyticsEvent, PlaycastAnalyticsVersion } from './types';

let initialized = false;
const version: PlaycastAnalyticsVersion = {
  version: constants.VERSION,
  environment: constants.ENVIRONMENT,
};

export const initialize = () => {
  const debug_mode = !(constants.VERSION.split('-')[1] === undefined);

  // Create options objects that only include debug_mode when it's true
  const gaOptions = debug_mode ? { debug_mode } : {};
  const gtagOptions = debug_mode ? { debug_mode } : {};

  ReactGA.initialize(constants.GA_TRACKING_ID, {
    gaOptions,
    gtagOptions,
  });

  initialized = true;
};

export const sendAnalytics = (event: PlaycastAnalyticsEvent): string => {
  if (!initialized) {
    initialize();
  }

  ReactGA.gtag('event', event.name, {
    ...event,
    ...version,
  });

  console.log('[Analytics] sent event', event);
  return 'analytics sent: '.concat(event.name);
};
